import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './styles/globals.css';
import { applyTheme, resolveTheme } from './store/themeSlice.js';

// ============================================================
// ТЕМА СТАВИТСЯ ДО ПЕРВОЙ ОТРИСОВКИ — И ЭТО ОБЯЗАТЕЛЬНО.
//
// 🔴 Если применить тему внутри React (в useEffect у ThemeProvider),
//    браузер успеет нарисовать СВЕТЛЫЙ фон по умолчанию, и только
//    потом сработает эффект. Пользователь увидит белую вспышку при
//    каждой загрузке — это классический FOUC.
//
//    Здесь тема проставляется на <html> синхронно, ещё до того как
//    React что-либо отрисовал. Стоит это доли миллисекунды, а вспышки
//    не будет вовсе.
//
// ⚠️ Значение дублирует логику `readStoredPreference` из themeSlice.
//    Продублировано намеренно: импорт слайса здесь тоже возможен, но
//    чтение localStorage должно быть максимально ранним и без побочных
//    эффектов инициализации стора. Ключ хранилища один — `studio-theme`.
// ============================================================
try {
  const saved = localStorage.getItem('studio-theme');
  applyTheme(saved || 'system');
} catch {
  // Приватный режим / отключённое хранилище — ставим системную тему.
  applyTheme('system');
}

// Следим за сменой системной настройки. Если пользователь выбрал
// конкретную тему ('light'/'dark'), редьюсер проигнорирует событие —
// см. `systemThemeChanged` в themeSlice.js.
if (window.matchMedia) {
  window
    .matchMedia('(prefers-color-scheme: dark)')
    .addEventListener('change', () => {
      // Переприменяем: resolveTheme сам разберётся, что сейчас активно.
      try {
        applyTheme(localStorage.getItem('studio-theme') || 'system');
      } catch {
        applyTheme('system');
      }
    });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
